import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

interface SSTAuthenticatePayload {
  userId: string; 
  companyName: string; 
  companyApiKey: string;
}

interface SSTAuthenticateResponse { 
  companyName: string;
  companyKey: string;
  companyType: string;
}

interface SSTConnectPayload {
  userId: string;
  companyId: string;
  companyApiKey: string;
}

@Injectable({
  providedIn: 'root'
})
export class ShipStationService {
  private readonly url = '/api/ship-station';

  constructor(private http: HttpClient) { }

  public authenticate(payload: SSTAuthenticatePayload) {
    return this.http.post<SSTAuthenticateResponse>(`${this.url}/authenticate`, payload)
  }

  public sync(payload: {
    userId: string,
    companyId: string
  }) {
    return this.http.post<{ status: string }>(`${this.url}/sync`, payload)
  }

  public testConnection(payload: {
    userId: string,
    companyId: string
  }) {
    return this.http.post<{ isConnectionOk: boolean, errorCode?: string }>(`${this.url}/test-connect`, payload)
  }

   public connect(payload: SSTConnectPayload) {
    return this.http.post<{ success: boolean }>(`${this.url}/connect`, payload)
  }
}
